import { IconButton, Spinner, SpinnerSize } from "@fluentui/react";
import React, { useContext } from "react";
import { DoubleTick, TailMessage } from "./CommunicationModal";
import SendMessageIcon from "../../components/SVGComponents/SendMessageIcon";
import { t } from "i18next";
import studyReportContext from "../../context/studyreport/StudyReportContext";

const CommunicationBottomSheet = (props) => {
  const { showCommunicationModal, setShowCommunicationModal } =
    useContext(studyReportContext);
  return (
    <div
      className="popup-viewer-content"
      style={{
        height: "100%",
        borderTopLeftRadius: "0px",
        borderTopRightRadius: "0px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          height: "50px",
          borderBottom: "1px solid #3D3D3D",
          padding: "10px",
          boxSizing: "border-box",
        }}
      >
        <span className="study-list-mobile-filter-txt">{t("heading.communication")}</span>
        <div className="study-list-mobile-close-icon-div" style={{ zIndex: 1 }}>
          <IconButton
            //style={{ color: "white" }}
            //style={{color : "var(--navbar-header-popup-color-txt)"}}
            style={{color : "var(--mobile-color-txt)"}}
            iconProps={{ iconName: "Cancel" }}
            ariaLabel="Close popup filter mobile"
            onClick={() => setShowCommunicationModal(false)}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-evenly",
          flexDirection: "column",
          height: "calc(100% - 100px)",
          borderBottom: "1px solid #3D3D3D",
        }}
      >
        <div style={{ height: "100%" }}>
          <div
            className="chat"
            style={{
              height: "90%",
              width: "90%",
              padding: "5%",
              overflowY: "auto",
              overflowX: "auto",
            }}
          >
            {/* <div
              id="main-body-scroll"
              style={{ position: "relative" }}
            > */}
            <div
              className="whatsapp-image-bg"
              style={{
                backgroundImage: `url(${window.location.origin}/images/backgroundImageNew.png`,
                backgroundColor: !props.isViewer
                  ? props.getThemeColor("modal-header-footer")
                  : "#222",
                position: showCommunicationModal ? "fixed" : "relative",
                zIndex: 0,
                height: "85%",
                top: "8%",
              }}
            ></div>

            {props.loading && (
              <div className="spinner-loading-msg">
                <Spinner
                  size={SpinnerSize.large}
                  styles={props.customSpinnerStyle}
                />
              </div>
            )}

            {props.messages.map((message, index) => (
              <p
                key={index}
                className={`chat__message ${
                  props.username != message.user.username
                    ? "message-in"
                    : "message-out"
                } ${
                  props.username == message.user.username && "chat__receiver"
                }`}
              >
                {props.username == message.user.username && (
                  <span className="tail-container">
                    <TailMessage flag={true} />
                  </span>
                )}
                {props.username != message.user.username && (
                  <span className="tail-container highlight">
                    <TailMessage flag={false} />
                  </span>
                )}
                {props.username != message.user.username && (
                  <span
                    // style={{color: getRandomColor()}}
                    className="chat__name"
                  >
                    {message.user.firstName} {message.user.lastName}
                  </span>
                )}
                <span
                  className="message-feedback"
                  style={{
                    marginRight: `${
                      message?.feedback?.length > 70 ? "25px" : "68px"
                    }`,
                  }}
                >
                  {message.feedback}
                </span>
                <span className="chat__timestamp date-time-react-style">
                  <span style={{ display: "flex", marginRight: "3px" }}>
                    {props.getFormatedTime(new Date(message.feedbackDate))}
                  </span>

                  {props.username == message.user.username && (
                    <span style={{ display: "flex" }}>
                      <DoubleTick />
                    </span>
                  )}
                </span>
                <span
                  style={{
                    color: props.getAlterColor("hsla(0,0%,100%,0.6)", ""),
                  }}
                  className="chat__time"
                >
                  {props
                    .getConsistentDateFormat(new Date(message.feedbackDate))
                    .slice(0, 9)}
                  {/* {getFormattedDate())} */}
                </span>
              </p>
            ))}
            <div ref={props.bottomRef} />
            {/* </div> */}
          </div>
        </div>
      </div>
      <div
        className="chat__footer"
        style={{ display: !props.checkForChildStudy() ? "flex" : "none", height: "50px" }}
      >
        {/* <InsertIcon /> */}
        <form
          style={{
            background: !props.isViewer
              ? props.getThemeColor("modal-header-footer")
              : "#222",
          }}
        >
          <input
            className="chat-input-field"
            value={props.inputMessage}
            style={{
              color: props.getThemeColor("primary-color"),
              background: "transparent",
            }}
            onChange={(e) => props.setInputMessage(e.target.value)}
            placeholder={t("placeholder.type-message")}
            type="text"
          />
          <button onClick={props.sendMessage} type="submit">
            <span style={{ display: "flex", marginLeft: "10px" }}>
              <SendMessageIcon   color ={props.getThemeColor("primary-color")}/>
            </span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default CommunicationBottomSheet;
